import {Currency} from "../generated/graphql";
import {renderAmount, CurrencyShort} from "./renderAmount";
import {isDefined} from "./typeScriptHelpers";

/**
 * Ohne `currency` gilt die Mandanten-Währung aus renderAmount. Explizit setzen nur
 * dort, wo der Betrag NICHT in der Mandanten-Währung steht — etwa in der
 * mandantenübergreifenden Superuser-Tabelle, die in Euro abrechnet.
 */
export const renderAsMoney = (
    amount: number | undefined,
    discountUnit: string | undefined | null,
    currency?: Currency | CurrencyShort,
) => {
    if (discountUnit !== "") {
        return isDefined(amount)
            ? `${renderAmount({amount, currency})} / ${discountUnit}`
            : undefined;
    }

    return isDefined(amount) ? renderAmount({amount, currency}) : undefined;
};
